
import pic from '@/utils/pic'
const { icon1, icon2, icon3, langzh, langen,langno, langtw, langjp, langxby,langit,langdy,langfy,langhy,langty,langyn,zhsz, jtrz, sfrz, iconchecked, iconcheck,icon1_01,icon1_02,icon1_03,icon1_04,banner01,banner02,banner03 } = pic

export default {
  currency: {
    bb: '교환',
    bba: '통화 계정',
    hy: '연락처',
    jg: '스왑',
    hya: '계약 계정'
  },
  index: {
    h24: '24시간 볼륨',
    header_title: ['디지털 자산 거래 선택 ' + window.GLOBAL.LANG_TITLE.zh],
    header_small_title:'완전한 원 스톱 블록 체인 디지털 자산 거래',
    header_msg: '안전하고 신뢰할 수있는',
    register_title: '등록 ' + window.GLOBAL.LANG_TITLE.zh + ' 글로벌 계정 거래 시작',
    register_pl: '이메일 또는 휴대폰을 입력하세요',
    register: '등록',
    featureTitleWhy: '왜 우리를 선택 했죠',
    featureTitle: '안전 · 안정 · 신뢰성',
    featureMsg: '',
    featureList: [
      {icon : icon1, title : '안전한 지갑 기술', msg : [ '콜드 앤 핫 월렛 기술은 세계 최고의 보안 팀에서 개발했으며 코인 손실 사고는 없었습니다. ','']},
       {icon : icon2, title : '풍부한 암호화 자산 사업', msg : [ '지원 현물 및 여러 파생 상품 거래 등은 암호화 자산 세계에 대한 귀하의 개인 청지기입니다. ','']},
       {icon : icon3, title : '전 세계에 분포 된 고객', msg : [ '전 세계 130 개 이상의 국가 또는 지역에있는 사용자를 위해 당사는 암호화 된 자산 서비스의 전체 범위를 제공합니다. ','']}
    ],
    bannerList: [
      {icon: banner01,title: "업계 최고의 보안 및 안정성 제공에 전념", msg: ["투자자 자산 안전을 보호하기 위한 스마트 계약", "실제 거래 성과", "24시간 서비스 보장"] },
      {icon: banner02,title: "간단한 조작으로 바로 사고팔고 싶다", msg: ["간단한 거래 화면", "계정 잔고에 바로 반영", "대부분의 암호화폐 거래 가능" ] },
      {icon: banner03,title: "결제계약 거래를 통해 적극적으로 수익을 내고 싶습니다.", msg: ["동시에 계좌를 개설하세요", "다수의 거래 선물에 대한 전략적 투자", "24개 거래가 가능합니다. 1년 365일, 주말에도 몇 시간 동안"]}
    ],
    featureList2: [
      {icon: icon1_01, title: "Transparency and Openness", msg: ["블록체인 및 스마트 계약의 특성을 사용하여 체인에서 트랜잭션 성능을 구현하고 스마트 계약을 사용하여 투자자 자산의 안전을 보장",""] },
      {icon: icon1_02, title: "Smart Investment", msg: ["최고의 양적 거래 전문가가 제공하는 다양한 전략으로 자유롭게 선택할 수 있습니다.",""] },
      {icon: icon1_03, title: "Risk grading", msg: ["각 투자자의 다양한 위험 및 자산 관리 선호도에 따라 다양한 투자 상품을 설계하여 투자 임계값을 효과적으로 제거", ""] },
      {icon: icon1_04, title: "Diversified products", msg: ["다양한 유형의 사용자 투자 요구와 유연한 플랫폼 메커니즘을 제공하고 시장보다 나은 혁신적인 금융 서비스를 지속적으로 생산합니다.", ""]}
    ],
    featureTitle2: '언제 어디서나 멀티 플랫폼 터미널 거래',
    featureMsg2: 'iOS 및 Android의 여러 플랫폼을 포괄하며 풀 서비스 기능을 지원합니다.',
    tab: ['주류 통화', '24 시간 상승 표 '],
    thead: ['이름', '최신가', '오늘의 최고가', '오늘의 최저가', '라이징리스트', '24H 볼륨', '오퍼레이션'],
    more: '더보기 >',
    btn: '트랜잭션',
    dealsTitle: '원 스톱 거래 서비스',
    dealsTab:[
      { title: '교환', content: '통화 거래는 다른 통화를 구매하기 위해 USDT를 평가 단위로 사용하는 디지털 자산 간의 교환을위한 것입니다.'+window.GLOBAL.LANG_TITLE.zh+'통화 거래는 Bitcoin, Ethereum 및 Litecoin과 같은 디지털 자산의 실시간 거래를 지원합니다.', src:'/static/image/deals-1.jpg', path: '' },
      { title: '연락처', content: '디지털 통화의 금융 파생 상품은 수익을 얻기 위해 매수 또는 매도 계약을 구매하는 선택을 지원할뿐만 아니라 운영이 간단하고 만료되지 않습니다.'+window.GLOBAL.LANG_TITLE.zh+'계약에는 최대 100 배의 레버리지가있는 고급 위험 관리 시스템이 있습니다.', src:'/static/image/deals-2.jpg', path: '' }
    ]
  },
  market: {
    tab: ['옵션', '계약', '코인'],
    thead: ['통화', '최근 가격', '24 시간 변동 ', '24 시간 최저', '24 시간 최고 ', '24 시간 거래량', '운용'],
    nodata: '데이터가 없습니다'
  },
  footer: {
    p: '©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
    dd: [
      {
        dt: "회사 소개",
        dd: [{title : "회사 프로필", id : 1}, {title : "지원 센터", type : 'help'}]
      },
      {
        dt: "사용자 지원",
        dd: [
          {title : "사용자 계약", id : 3},
          {title : "개인 정보 보호 정책", ID : 5}
        ]
      },
      {
        dt: "문의하기",
        icon: true
      }
    ]
  },
  nav: {
    btn: ["로그인", "등록", "자산 관리", "앱 다운로드"],
    nav: [
      { title: "홈", path: "/index",name: 'index' },
      { title: "시장", path: "/market",name: 'market' },
      // { title: "교환", path: "/deal", name: 'deal'},
      // { title: "연락처", path: "/deal_c", name: 'deal_c' },
      { title: "스왑", path: "/deal_jg", name: 'deal_jg' },
      { title: "리베이트 보유", path: "/profit_index",name: 'profit_index' }
    ],
    nav2: [{ title: "내 자산", path: "/asset" }],
    menus: [
      {icon : langzh, title : "사용자 센터", path : "/setting"},
      {icon : langen, title : "로그 아웃"}
    ],
    lang: [
      { icon: langen, lang: "English", key: 'en' },
      {
        icon: langno,
        lang: "Norsk",
        key: 'no'
      },
      {"icon": langit,"lang": "Italiano","key": "it"},
      { icon: langxby, lang: "España", key: 'es' },
      { icon: langfy, lang: "français", key: 'fr' },
      { icon: langdy, lang: "Deutsche", key: 'de' },
      { icon: langjp, lang: "日本語", key: 'jp' },
      { icon: langhy, lang: "한국어", key: 'kr' },
      { icon: langty, lang: "ไทย", key: 'th' },
      { icon: langyn, lang: "Tiếng Việt", key: 'vn' },
      { icon: langzh, lang: "简体中文", key: 'zh' },
      { icon: langtw, lang: "繁體中文", key: 'tw' },
    ]
  },
  download:{
    "xz": "다운로드"
  },
  // 登录
  login: {
    login: '로그인하세요',
    msg: '등록 된 계정을 입력하세요',
    list: ['모바일 / 이메일', '비밀번호', '비밀번호 분실', '로그인', '계정 없음, 지금 등록'],
    message: '계정 또는 비밀번호는 비워 둘 수 없습니다.'
  },
  register: {
    dl: ['모바일 등록', '이메일 등록'],
    title: '계정 등록',
    country: '시민권 국가',
    country_info: '등록 후 국적 정보는 수정할 수 없으므로 정직하게 선택 해주세요.',
    account: '계좌 번호',
    code_text: '확인 코드',
    code_btn: 'CAPTCHA 받기',
    code_unit: 's',
    code_no_data: '인증 코드를 입력해야합니다.',
    password_text: '암호를 입력해 주십시오',
    password_again_text: '암호 다시 입력',
    pid_text: '초대 코드',
    pid_pl: '선택 과목',
    invitation_code_no_data: '초대 코드가 필요합니다.',
    xy: '사용자 동의',
    xy_no_checked : '프로토콜을 선택하십시오',
    agree : '나는 읽고 동의했습니다',
    register_btn : '등록',
    bz: ['등록 후 국적 정보는 수정할 수 없으니 정직하게 선택하시기 바랍니다. ','확인 메일은 스팸으로 오인 될 수 있으니주의 깊게 확인하시기 바랍니다. ','계정을 올바르게 유지하십시오 '+ window.GLOBAL.LANG_TITLE.zh +'계정 및 로그인 비밀번호. ','다른 웹 사이트와 동일한 로그인 비밀번호를 사용하지 마십시오. '],
    account_no_data: '계정은 비워 둘 수 없습니다.',
    code_no_equality: '확인 코드가 동일하지 않습니다.',
    password_no_data: '비밀번호는 비워 둘 수 없습니다.',
    password_no_equality: '두 암호가 같지 않습니다.'
  },
  // 设置密码
  bindmpwd: {
    title: '암호를 설정하세요',
    account: '계좌 번호',
    code_text: '확인 코드',
    code_btn: 'CAPTCHA 받기',
    code_unit: 's',
    password_text: '암호를 입력해 주십시오',
    password_again_text: '암호 다시 입력',
    code_no_data: '인증 코드를 입력해야합니다.',
    code_no_equality: '확인 코드가 동일하지 않습니다.',
    password_no_data: '비밀번호는 비워 둘 수 없습니다.',
    password_no_equality: '두 암호가 같지 않습니다.',
    bindmpwd_btn: '확인',
    phone_no_data: '전화 번호는 비워 둘 수 없습니다.',
    password_login_text: '로그인 암호를 입력해 주십시오',
    password_trade_text: '암호 길이 6자리',
    password_again_tarde_text: '암호 길이 6자리',
  },
  // 忘记密码
  forgetpwd: {
    title: ['비밀번호 수정', '비밀번호 분실'],
    account: '계좌 번호',
    code_text: '확인 코드',
    code_btn: 'CAPTCHA 받기',
    code_unit: 's',
    password_text: '암호를 입력해 주십시오',
    password_again_text: '암호 다시 입력',

    phone_no_data: '전화 번호는 비워 둘 수 없습니다.',

    account_no_data: '계정은 비워 둘 수 없습니다.',
    code_no_data: '인증 코드를 입력해야합니다.',
    code_no_equality: '확인 코드가 동일하지 않습니다.',
    password_no_data: '비밀번호는 비워 둘 수 없습니다.',
    password_no_equality: '두 암호가 같지 않습니다.',
    forgetpwd_btn: '확인'
  },
  // 绑定手机号码
  bindphone: {
    title: '휴대 전화 번호 바인딩',
    phone_text: '전화 번호',
  },
  person: {
    more: '더 많이 불러오기',
    no_more: '더 이상 데이터 없음',
    index_center:"사용자 센터",
    index_menus: [
      { icon: zhsz, title: "계정 관리", path: '/setting' },
      { icon: sfrz, title: "KYC 인증", path: '/sfyz' },
      { icon: sfrz, title: "주니어 자격증", path: '/smauth' },
      { icon: sfrz, title: "시니어 자격증", path: '/seniorauth' },
      { icon: jtrz, title: "주소 인증", path: '/dzrz' },
      { icon: jtrz, title: "암호화폐 매입", path: '/kjmbSelect' },
      { icon: jtrz, title: "신용 점수", path: '/credit' },
      { icon: jtrz, title: "기록", path: '/deallog' },
      { icon: jtrz, title: "예치 기록", path: '/cbjl' },
      { icon: jtrz, title: "인출 기록", path: '/tbjl' },
    //  { icon: jtrz, title: "我的消息", path: '/news' }
    ],
    cbtb: '예치 및 인출',
    jymx: '거래 상세 정보',
    xyf: {
      'title': '신용 점수',
       'pgsj': '평가 시간'
    },
    smrz:{
       title:'시니어 자격증' ,
       sure_title : '실명 인증 통과',
       zj_type : '인증서 유형',
       zj_info : [ '1, 인증 정보는 일단 확인되면 수정할 수 없습니다. 사실대로 입력 해주세요', '2, 인증 된 실명 정보는 재 인증 불가'],
       zj_name : '이름',
       zj_num : '문서 번호',
       zj_btn : 'OK',
       zj_rebtn : '재 검증',
       zj_sebtn : '고급 검증',
       zj_type_array:[{name:'ID 카드',type:'idcard'}],
       idCardArr: [
        {
            id: 1,
            name: "ID 카드"
        },
        {
            id: 2,
            name: "여권"
        },
        {
            id: 3,
            name: "운전면허증"
        },
        {
            id: 4,
            name: "거주 허가"
        },
        {
            id: 5,
            name: "다른"
        }
       ],
       zj_data:{city:'국적은 비워 둘 수 없습니다.',type:'자격 증명 유형은 비워 둘 수 없습니다.',name:'이름은 비워둘 수 없습니다',zj_num:'ID 번호는 비워둘 수 없습니다'},
       zsxm: '실제 이름',
       qsrzsxm: '실제 이름을 입력해 주십시오',
       zjlx: '유효한 신분증(ID) 유형',
       qxzzjlx: 'ID 유형을 선택해 주십시오',
       sfz: 'ID 카드',
       zjhm: 'ID 번호',
       qsrzjhm: 'ID 번호를 입력해 주십시오',
       sczjz: 'ID 사진 업로드',
       zjzm: 'ID 문서의 앞면 사진 업로드',
       zjfm: 'ID 문서의 뒷면 사진 업로드',
       qsczjzm: '신분증 앞면 사진을 업로드 해주세요.',
       qsczjfm: '신분증 뒷면 사진을 업로드 해주세요.',
       scqmz: 'ID 문서 및 개인 서명 업로드',
       qscscqmz: '신분증과 개인 서명 사진을 업로드 해주세요.',
       zj: [
         {
           id: 1,
           title: 'ID 카드'
         },
         {
           id: 2,
           title: '여권'
         },
         {
           id: 3,
           title: '다른'
         },
       ],
       tj: '제출',
       shz: '검토 중',
       shtg: '승인됨'
    },
    gjrz:{
      title:'시니어 자격증',
      zj_info:['1. 8MB보다 작은 크기의 JPG JPEG 또는 PNG 포맷의 이미지들이 지원됩니다.','2. ID 문서 사진은 선명해야 하고 수정되거나 가려져서는 안 됩니다. 개인 사진 문서 번호와 문서 보유자의 이름이 선명하게 드러나야 합니다.','3. 사진은 모자를 쓰지 않은 상태로 촬영되어야 하고 화장을 하지 말 것을 권장합니다. 사진의 안면 기능들이 선명하고 알아볼 수 있어야 하며, 팔이 안전히 노출되어야 합니다.'],
      zj_img:['/static/image/User_Center_Front_view.png','/static/image/User_Center_Back_Shot.png','/static/image/User_Center_Full_picture.png'],

    },
    zhgl:{
      title:'보안 설정',
      bind:[{bind_title : '암호 재설정', bind_name : 'Email'}, {bind_title : '거래 암호 설정', bind_name : 'Email'}]
    },
    wdtg:{
      own_code : '독점 초대 코드',
      own_code_url : '독점 초대 연결',
      own_push_title : '내 프로모션',
      own_push_content : [ '총 초청 수익 (가치)', '초대 수', '사람'],
      own_push_content_profit : [ '레벨 1 초대 혜택', '레벨 2 초대 혜택', '레벨 3 초대 혜택', '레벨 4 초대 혜택'],
      own_push_content_num : [ '1 단계 초대 수', '2 단계 초대 수', '3 단계 초대 수', '4 단계 초대 수'],
      own_push_profit_title : [ 'ID', 'profit', 'remarks information', 'add time'],
      own_push_num_title : [ 'ID', 'name', 'phone', 'add time'],
    },
    jyzt_td : [ '시간', '상세', '금액'],
    cbjl_td : [ '시간', '통화', '수량', '상태'],
    sfrz_txt : [ '본인 인증', '감사를 제출하셨습니다. 결과를 기다려주세요', '고급 인증을 통과했습니다', '신분증 앞', '신분증 뒷면', '인증', ' 인증에 실패했습니다. 다시 인증하십시오. '],

    zhsz_txt : [ '계정 보안 수준 : #', '계정 보안 수준 : #, 추가 정보 개선 및 계정 보안 보장'],
    zhsz_m : 'strong',
    zhsz_n : '약함',
    zhsz_p : '안전하지 않음',
    zhsz_detailList: [
      { icon: '/static/image/User_Center-password.png', title : '로그인 비밀번호', value : '인터넷 계정이 도용 될 위험이 있습니다. 계정 보안을 위해 정기적으로 비밀번호를 변경하는 것이 좋습니다. ', value2 :'', btn : '수정', bind_email : '먼저 이메일 또는 휴대폰을 바인딩하십시오', path: '/forgetpwd?type=changepwd' },
      { icon: '/static/image/User_Center-password.png', title : '거래 비밀번호', value : '비밀번호 설정', btn : '설정으로 이동', path: '/bindmpwd' }
    ],
    sksz_txt : [ '영수증 설정', '저장'],
    sksz_list: [
      { label: "用户名:", pl: "请输入用户名", key: "name" },
      { label: "开户行名称:", pl: "请输入开户行名称", key: "bank_name" },
      { label: "银行卡号:", pl: "请输入银行卡号", key: "bank_number" },
      { label: "支付宝账号:", pl: "请输入支付宝账号", key: "alipay_account" },
      { label: "微信昵称：", pl: "请输入微信昵称", key: "weixin_nickname" },
      { label: "微信账号：", pl: "请输入微信账号", key: "weixin_account" }
    ]
  },
  pasination: {
    first : '집',
    prev : '이전 페이지',
    next : '다음 페이지',
    last : '마지막 페이지',
    no_data: '데이터가 없습니다',
  },
  asset: {
    title: '내 자산',
    zjhz: '자금 이체',
    cb: '예치',
    gz: 'USDT 평가',
    atnv: [],
    zh_title: '전환 된 총 자산：',
    index_title: '자산',
    address_title: '통화',
    address_txt: ['선택하세요', '인출 주소', '내용을 입력하세요', '비고', '주소 목록'],
    address_btn: ['추가', '저장', '삭제', '편집'],
    address_td: ['통화', '인출 주소', '비고', '작업'],
    currency_td: ['통화', '이용 가능', '동결', '전환'],

    table_title: '총 자산：',
    table_address_title: '출금 주소 관리',
    table_td: ['통화', '이용 가능', '동결', '전환', '작업'],
    table_btn: ['예치', '인출', '记录', '이전'],

    money_text: ['인출 주소', '선택하세요', '금액', '이용 가능：', '수수료',
      '도착 금액', '거래 암호','태그 (메모)','최소 '],
    money_btn: '인출',
    xzbz: '통화 선택',
    money_msg: ['미리 알림', '1. 출금 시간은 홍콩 시간 12 : 00-24 : 00, 하루 2 회 출금 신청 (최소 출금 100u, 최대 출금 200,000u)', '2. 현재 출금은 USDT 통화 만 지원되며, 지갑 링크 유형 선택 ERC20; ','3. 출금 신청서 제출 후 출금이 진행 중이기 때문에 자금이 동결되며, 자금은 시스템에 의해 일시적으로 관리되며 귀하가 자유롭게 관리 할 수 ​​없습니다. 자산을 잃어 버렸거나 자산이 비정상적인 것은 아닙니다. 승인을 기다려주세요. ','4. 출금 신청서 제출 후 도착 시간은 블록 확인 시간에 따릅니다. 출금 시간 이후에도 출금이 예상되지 않을 경우 고객 센터로 문의하시기 바랍니다. ',' 5. 현재 행동을 막기 위해 출금을 시작하려면 총 소비량의 90 %가 필요합니다. '],

    recharge_title: '재충전 주소',
    recharge_btn: ['복사', 'QR 코드', '예치'],
    recharge_text: ['금액', '미리 알림', 'USDT가 아닌 자산을 위 주소로 충전하지 마십시오. 그렇지 않으면 자산이 회수되지 않습니다. ','USDT 입금은 단순 송금 방식 만 지원하며, 다른 방식으로 입금 (모두 보내기)은 일시적으로 게시 할 수 없으므로 양해 바랍니다. ','신임장', '바우처 설명(선택 과목)','체인 이름'],

    record_title: '재무 기록',
    record_td: ['금액', '녹음', '시간'],

    transfer_title: '이전',
    transfer_btn: ['모두', '전송'],
    transfer_text: ['에서', '...에', '이체 금액을 입력하세요', '이용 가능：'],
    "bq": "태그 (메모)",
    "qsrbq": "태그를 입력해 주십시오",
    "yhktx": "은행 카드 인출",
    "yhmc": "은행 이름",
    "qsryhmc": "은행 이름을 입력해 주십시오",
    "yhzh": "은행 계좌",
    "qsryhzh": "은행 계좌를 입력해 주십시오",
    "gjhkdm": "SWIFT 코드",
    "qsrgjhkdm": "SWIFT 코드를 입력해 주십시오",
    "yhdz": "은행 주소",
    "qsryhdz": "은행 주소를 입력해 주십시오",
    "skrxm": "수취인 이름",
    "qsrskrxm": "수취인 이름을 입력해 주십시오",
    "skrdh": "수취인 전화",
    "qsrskrdh": "수취인 전화를 입력해 주십시오",
    "skrdz": "수취인 주소",
    "qsrskrdz": "수취인 주소를 입력해 주십시오"
  },
  text: {
    btn : '반환',
    login : '먼저 로그인하십시오'
  },
  deal: {
    chooseType: '커미션 유형',
    choose: '선택하세요',
    balance: '잔고：',
    account: ['계정', '사용 가능', '/ Freeze', 'Transfer'],
    dir: ['매입', '매도'],
    dir2: ['이용 가능', '판매 가능'],
    cs: '선택 사항',
    sxf: '요금',
    jye: '회전율',
    sc_list: ['시장', '이름', '가격 상승'],
    sc_h: ['Latest', '24H Lowest', '24H Highest', '24H Vol.'],
    td_lt : [ '통화', '최신 가격', '상승 가격'],
    k_line_txt : [ '≈', '', '증가', '최고가', '최저가', '24 시간 볼륨 '],
    tabListLTitle: ["대기 주문", "커미션 이력"],
    tabListLEntrust: ["매입", "매도"],
    tabListRTitle: ["거래 제한", "시장 거래"],
    table_btn: ['주문 취소'],
    index_td_l: ['시간', '거래 대상', '수량', '가격', '운영'],
    index_td_r: ['최근 가격', '방향', '가격', '수량'],
    index_td_r2: ['최근 거래', '시간', '가격', '거래량'],
    table_txt: ['완료됨', '주문 취소됨'],
    db_1_txt: ['유효한', '구매 가격', '판매 가격', '바이 인', '판매량', '거래 금액', '시장에서 가장 좋은 가격에 구매', '시장에서 최고의 가격으로 판매', '손 구매', '손 판매'],
    db_2_txt: ['가격', '지렛대', '선택하세요', '제비', '1로트 =', '로트', '계약 시장 가치', '여유', '시장에서 가장 좋은 가격에 구매', '시장에서 최고의 가격으로 판매'],
    pathList : [ '계약 기록', '거래 기록'],
    db_btn: ['구매 (매수)', '매도 (숏)'],
    tabListLTitle2: ['대기 주문'],

    lt_btn: ['원클릭 환금', '손절매 및 손절매 가격 설정', '클로즈', '지금 제출', '반환'],
    lt_txt: ['위험률 :', '총 수익'],
    lt_td : [ 'Type', 'Leverage Multiple', 'Position Price', 'Current Price', 'Margin', 'Take Profit Price', 'Stop Loss Price', 'Open Time', 'Number of Lots', ' 손익 ','Operation '],
     lt_dl : [ '손절매 및 손절매 가격 설정', 'Stop Profit Price', 'Stop Loss Price'],

    lt_0_btn: ['주문 취소'],
    lt_0_td: ['연락처', '통화', '수량', '현재 가격', '취급 수수료', '운용'],

    lt_1_btn: ['클로즈'],
    lt_1_txt: ['청산'],
    lt_1_td: ['유형', '포지션 가격', '현재 가격', '마진', '수익 가격', '손절매 가격', '개장 시간', '취급 수수료', '손익', '운영'],
    node_data: '데이터가 없습니다',

    lt_3_txt: ['청산됨', '변제'],
    lt_3_td: ['유형', '제비', '포지션 가격', '종가', '수익 가격 취하기', '손실 중단 가격', '본드', '이용 가능 마진', '개시 시간', '청산 시간', '수수료',
      '수익 및 손실', '작업'],

    lt_4_txt: ['주문 취소됨'],
    cm: ['배포 시간', '발행 번호', '流通总量', '总凑价格', '공식 웹사이트','백서','介绍'],
    qsrsl: '금액을 입력해 주십시오',
    qsrss: '로트를 입력하세요',
  },
  notice:{
      notice_title:'발표 센터',
  },
  bzhl:{
    title: '리베이트 보유',
    ttzbt: '天天赚不停',
    wdtg: '내 호스팅',
    zztgdzj: '보호 예수 자금',
    yjjrsy: '매일 추정',
    ljsy: '총 수입',
    tgzdd: '보호 예수 주문',
    tgdd: '에스크로 주문',
    t1: '위험이 적고 안정적인 재무 관리, 필요한 경우 언제든지 상환 가능',
    t2: '무료 자금 관리 도우미',
    cljxcp: '상품 주기',
    dbxe: '단일 한도',
    rsyl: '생산하다(%)',
    rsyl2: '일일 수익률：',
    zq: '주기',
    qmr: '구매하기',
    ckgd: 'xem thêm',
    cpgk: '제품 개요',
    pxsj: '배당금 지급 시기',
    tgzj: '보호 예수 자본',
    tqsh: '조기 상환',
    cpld: '상품 하이라이트',
    cpgz: '제품 규칙',
    cont: '브릭 이동은 플랫폼에서 USDT를 호스팅하는 것이며, 플랫폼의 전문 팀은 브릭을 이동할 권리가 있습니다. 참가자는 언제든지 액세스 할 수있는 펀드 보관 기간 동안 브릭 이동 수입에서 플랫폼의 몫을 얻을 수 있습니다. 안전하고 편리합니다.',
    zj: '100% 펀딩',
    aqbz: '보안',
    jjrsy: '공휴일 수입',
    bjd: '무중단',
    cgcrh: '성공적인 예치 후',
    dtqx: '오늘의 이자 가치',
    ljzr: '지금 전송',
    xqglgj: '무료 자금 관리 도구',
    ddh: '주문 번호',
    tgje: '보호 예수 금액',
    tgsj: '주기 일',
    yhl: '수익:',
    xdsj: '주문 시간',
    zt: '상태',
    fh: '반환',
    qrnhsy: '七日年化收益',
    ygy: '1个月',
    bn: '半年',
    yn: '1年',
    yuan: '元',
    tzfx: '투자 위험',
    shsc: '교환 시간',
    di: '로우',
    yggzr: '1 일',
    msgsxf: '무료 구독료',
    mr: '매일',
    dqfh: '기한 만료 시 반환',
    ljgm: '지금 매입',
    tgz: '보호 예수 중',
    sh: '상환',
    ywc: '완료됨',
    ysh: '상환됨',
    all: '모두',
    "xzbzts": "간단하고 안전합니다. 배당금은 여러 통화로 선택할 수 있습니다.",
    "qtbz": "기타 동전"
  },
  pay:{
    qsrjymm: '6 자리 거래 비밀번호를 입력하세요',
    tbmmts: '거래 비밀번호를 설정하려면 사용자 센터로 이동하세요.',
  },
  tips:{
    qxztbdz: '인출 주소를 입력해 주십시오',
    qsrtbsl: '인출 통화의 수량을 입력해 주십시오'
  },
  statusText: ['실패', '처리 대기 중', '성공'],
  dzrz: {
    title : '주소 인증',
    sdddz : '유틸리티 청구서 주소',
    zdtpsc : '빌 사진 업로드',
    qsrsdddz : '주소 정보를 입력하고 공과금 청구서 또는 광대역 주소 청구서를 제출해야합니다.',
    qsczdtp : '청구서 사진을 올려주세요',
    status : [ '검토 중', '검토 통과'],
    qd : 'OK',
  },
  jgcc: {
    wtgd: '보류 중 주문',
    cj: '딜',
    jj: '정보',
    zc: '현재',
    lszc: '이력',
    qblx: '모든 유형',
    xj: '현재 가격',
    sj: '시간',
    fx: '방향',
    jg: '가격',
    sl: '금액',
    jgsj: '배송 시간',
    gmj: '구매가',
    jsj: '정산가',
    yk: '수익 및 손실',
    xq: '상세 정보',
    mz: '롱 매입',
    md: '쇼트 매도',
    dqye: '현재 잔고',
    gb: '클로즈',
    jxxd: '계속 주문',
    qrxd: '확인',
    ddqr: '주문 확인',
    sxf: '요금',
    kyye: '균형',
    jypz: '이름',
    jyfx: '방향',
    tzje: '투자 가격',
    tzjeTips: '투자 금액은 0 일 수 없습니다.',
    dqsj: '만료 시간',
    jssj: '배송 시간',
    gmsj: '구매 시간',
    sy: '수익',
    zxje: '최소 금액 ',
    shi: 'H',
    fen: 'M',
    miao: 's',
    zdje: '최대 금액 ',
    qsrje: '금액을 입력하세요',
    zxtzje: '최소 수량 ',
    yebz: '잔액 불충분',
    xq: '상세 정보',
    ddz: '기다리는',
    jgjl: '납품 실적',
    bz: '통화',
    cz: '작업'
  },
  kjmb: {
    title: '암호화폐 매입',
    fzcg: '성공적으로 복사',
    ljmb: '암호화폐 매입',
    lxkf: '고객 서비스에 문의'
  },
  news: {
    title: '내 메시지',
    "gg": "알림",
    ckxq: '상세 정보 보기'
  },
  statusTabs:['주문 보류', '거래','청산됨', '인출됨'],
  "chongzhi":{
    "zy": "중요한",
    "cbxx": "토큰 예치 정보",
    "qrsl": "입금 금액을 입력하십시오",
    "tips2": "1. 지갑/플랫폼 호환성: 즉, 네트워크가 지원되며 대상 플랫폼이 출금 네트워크를 지원하지 않는 경우 자산을 검색할 수 없습니다.",
    "tips3": "2. 귀하의 탑업 네트워크와 대상 플랫폼이 동일하며, 대상 주소를 이더리움 네트워크로 선택했지만 탑업이 TRC20 스마트체인을 선택한 경우 디지털 자산을 검색하지 못할 수 있습니다.",
    "tips4": "3. 충전하기 전에 주소와 금액이 정확한지 확인하십시오.",
    "tips5": "알림: 블록 네트워크의 익명성과 개인 정보 보호로 인해 잘못된 정보를 입력하면 해당 자산을 잃게 됩니다. 충전 주소와 수량을 잘 확인하세요.",
    "tip2_1": "• 위 주소로 현지 통화가 아닌 자산을 청구하지 마십시오. 그렇지 않으면 자산을 검색할 수 없습니다.",
    "tip2_2": "• 디지털 화폐는 제시간에 배송될 수 없습니다. 실제 도착 시간은 블록체인의 확인 속도에 따라 다릅니다.",
    "tip2_3": "• 충전 주소는 자주 변경되지 않으며 충전할 수 있습니다. 변경 사항이 있는 경우 웹사이트 공지 또는 이메일을 통해 알려 드리겠습니다.",
  },
  "tibi":{
    "tbxx": "출금 정보",
    "qsrbq": "레이블을 입력하십시오",
    "tbTips1": "• 자금의 안전을 위해 계정 보안 정책이 변경되거나 비밀번호가 변경될 경우 수동으로 출금을 검토하므로 직원이 전화 또는 이메일로 연락을 드릴 때까지 참을성 있게 기다려 주십시오.",
    "tbTips2": "• 정보가 변조되거나 유출되지 않도록 컴퓨터와 브라우저가 안전한지 확인하세요.",
    "tbTips3": "• 귀하가 언급한 디지털 자산은 원코인 멀티체인 자산입니다. 어떤 체인에서 모으기를 선택하든, 이는 귀하가 소유한 출금 페이지에 표시되는 디지털 자산의 총량이 감소한다는 것을 의미합니다 해당 금액만큼.",
  },
  "gjlb": "목록 국가 목록",
  "qxzgjlb": "국가 / 지역을 선택하십시오",
  "mbwt":{
    "title": "보안 문제 설정",
    "mbwt": "보안 문제들",
    "problem":[
      {
        "id": 1,
        "title": "어렸을 때 가장 친했던 친구는?"
      },
      {
        "id": 2,
        "title": "당신의 우상은 누구입니까?"
      },
      {
        "id": 3,
        "title": "가장 그리운 곳은 어디인가요?"
      }
    ],
    "qtxda": "답변을 작성해주세요",
    "qsrxmm": "새 비밀번호를 입력하세요",
    "qqrmm": "암호를 확인해 주십시오",
    "sydqmmcz": "현재 비밀번호 재설정 사용",
    "zhmm": "보안 문제 비밀번호 검색",
    "ysz": "설정되었습니다",
    "tg": "뛰어 넘다",
    "tj": "제출하다",
    "zyts": "중요한:",
    "zytsCont": "비밀번호와 인증번호를 공개하지 마시고, 비밀번호 찾기에 도움이 되는 보안 문제를 염두에 두시기 바랍니다."
  },
  "zc":{
    "zclb": "자산 목록",
    "zczh": "자산 전환",
    "yczc": "보유하고 있지 않은 자산 숨기기"
  },
  "indexNew":{
    "t1": "글로벌 리딩",
    "t2": "디지털 자산 서비스 플랫폼",
    "t3": "원스톱 블록체인 디지털 자산 거래 완료",
    "t4": "휴대폰 번호/이메일",
    "t5": "지금 등록",
    "t6": "GMO Global을 통해 전 세계 고객을 환영합니다",
    "t7":"암호화 여정을 발견하고 시작하세요"
  },
  "newReg":{
    "dl": ['이메일','휴대전화'],
    "cjzh": "계정 만들기",
    "sysjhzyx": "휴대폰 번호/이메일로 등록",
    "yhxy": "&lt;이용약관&gt;",
    "yhxy2": "및 &lt;이용약관&gt;을 읽었으며 이에 동의합니다.",
    "yxgz": "유효한 이메일을 입력하십시오",
    "dhgz": "휴대폰 번호가 잘못되었습니다"
  },
  "indexNew2":{
    "t1": "주문에 따라 거래",
    "t2": "비트뱅크 사용",
    "t3": "Bitbank는 독창적으로 설계된 비트코인 ​​및 암호화된 자산 거래소입니다. 매우 간단하고 편리하며 안전하고 강력합니다. 여러 웹 및 스마트폰 플랫폼에서 거래를 지원합니다. 거래 데이터와 차트는 실시간으로 업데이트됩니다. 종합 시장 가격 분석은 60개 이상의 기술적 분석 도구를 제공합니다. 거래 시작",
    "ksjy": "거래 시작",
    "ly": "비트뱅크를 선택해야 하는 5가지 이유",
    "item1_t1": "주요 거래량",
    "item1_t2": "No.1 * 암호화 자산 거래량",
    "item1_t3": "높은 유동성, 편안한(즐거운 거래 경험) 거래. 12가지 유형의 암호화 자산을 나열하십시오.",
    "item2_t1": "높은 타사 평가",
    "item2_t2": "안전한 거래 환경",
    "item2_t3": "오프라인 콜드 월렛을 사용하십시오. Multisig를 사용하여 해커를 차단하십시오. 첨단 기술로 자산을 보호하십시오",
    "item3_t1": "사용하기 쉽고 안정적인 응용 프로그램",
    "item3_t2": "사용하기 쉽고 간단한 응용 프로그램",
    "item3_t3": "풍부한 기능을 갖춘 안정적인 응용 프로그램입니다. 트랜잭션 외부에서 거래 기회를 유지할 수 있습니다.",
    "item4_t1": "하루 종일 영업",
    "item4_t2": "금을 입금할 수 있음",
    "item4_t3": "공휴일 포함 24시간 입금 지원!",
    "item5_t1": "스마트폰 및 PC",
    "item5_t2": "인간화된 디자인",
    "item5_t3": "스마트폰을 이용해도 망설임 없이 간편하고 적격한 거래를 할 수 있다",
    "aqkk": "안전하고 신뢰할 수 있음",
    "aqkk2": "비트뱅크 비트코인 ​​거래",
    "cjzh": "계정 만들기",
  },
  "xbsg":{
    "title": "동전 구매",
    "wdsg": "세부",
    "scts": "락업일: ",
    "sy": "남은",
    "ljsg": "지금 구독",
    "ysk": "매진",
    "xzjdy": "지금 구독",
    "dy": "구독하다",
    "fxjg": "발행 가격",
    "fxl": "순환",
    "ssrq": "상장일",
    "yxqx": "유효 기간",
    "qsrsl": "수량을 입력해주세요",
    "syl": "남은",
    "sgrq": "구독 날짜",
    "sgsl": "양",
    "bz": "동전",
    "yebz": "USDT 잔액 부족",
    "tgsl": "패스 수량",
    "shz": "검토 중",
    "wtg": "실패",
    "ytg": "통과"
  },
  "wydb":{
    "title": "빌리다",
    "db": "빌리다",
    "dbz": "빌리다",
    "jl": "기록",
    "jdzq": "기간(일)",
    "qhk": "갚다",
    "ljdb": "누적(usdt)",
    "dhkbs" :"지불 보류",
    "jkje": "대출금액(usdt)",
    "qsrje": "수량을 입력해주세요",
    "rll": "일일 이자율",
    "hkfs": "반환",
    "dqych": "만료됨",
    "lx": "관심",
    "fkjg": "대주",
    "tpsc": "신용대출(이미지 업로드)",
    "fwxx": "주택정보",
    "srzm": "소득 증명(고용 관계)",
    "yhmx": "은행 명세서",
    "zjz": "신분증 사진",
    "yd": "읽고 동의했습니다",
    "xy": "대출 계약 신청",
    "sqdb": "대출 체인 신청",
    "gb": "폐쇄",
    "qd": "확인",
    "ts": "대출 계약 신청을 확인하십시오",
    "dbjl": "기록",
    "hkhth": "주문 코드",
    "wsh": "미검토",
    "yfk": "대출",
    "sqrq": "신청 시간",
    "zq": "주기",
    "dbsl": "갈비뼈의 수",
    "zhke": "총 지불",
    "yhkxq": "상환내역",
    "bqyhk": "현재 기간에 상환 가능(USDT)",
    "hktips": "잔액이 충분한지 확인하시고, 잔액이 부족할 경우 충전 후 상환하시기 바랍니다.",
    "bj": "주요한",
    "jie": "빌리다",
    "ljhk": "즉시 상환",
    "qcz": "입금하기",
    "yebzqxcz": "잔액이 부족합니다. 먼저 충전한 다음 상환하세요.",
    "znj": "연체료",
    "yqts": "연체일수"
  },
  "hkxq":{
    "dd":"주문하다",
    "fzhkdz":"상환 주소 복사",
    "hkxq": "상환내역",
    "zlx": "총 이자",
    "zhk": "총 상환액",
    "hkjg": "상환 기관",
    "qschkpz": "상환 증명서를 업로드하십시오",
    "hkpz": "상환 증명서"
  },
  "bbjyNew":{
    "jylx": "유형",
    "jyze": "양"
  },
  "bind":{
    "title": "우편",
    "ybd": "경계",
    "wbd": "매여 있지 않은",
    "ts": "계정을 보호하려면 이메일 주소를 묶는 것이 좋습니다.",
    "qsryxdz": "이메일 주소"
  },
  "tipsNew": {
    "yjj": "거부",
    "shz": "구원"
  },
  "newIndex2":{
    "zxhy": "최신 인용구",
    "jypt": "거래 플랫폼",
    "dqwz": "현재 위치",
    "yzm": "인증 코드",
    "qrmm": "비밀번호 확인",
    "djdl": "로그인하려면 클릭하세요.",
    "ghdjy": "더 나은 거래",
    "ghdsh": "더 나은 삶",
    "about": "세계에서 가장 혁신적인 암호 교환 센터가 여기 있습니다. 여기에서 수백 개의 암호 화폐로 암호 화폐를 구입, 거래 및 얻을 수 있습니다.",
    "index01": "비트코인 및 그 이상으로 가는 관문",
    "index02": "세계 최고의 디지털 자산 서비스 플랫폼",
    "index03": "모든 거래는 무료입니다",
    "index04": "계좌 개설 수수료, 계좌 유지 수수료, 손절매 수수료, 예금 수수료, 보관/배송 수수료는 모두 무료입니다.",
    "index05": "안전하고 안전한 보안",
    "index06": "GMI INT는 창립 이래 축적한 전문 지식을 활용하여 고객의 자산을 안전하고 안전하게 보호하기 위해 강력한 시스템을 구축하고 다양한 보안 조치를 구현하고 있습니다.",
    "index07": "물리적 거래와 레버리지 거래가 모두 가능합니다.",
    "index08": "소액 거래는 약 $10부터 가능하며 스프레드는 업계에서 가장 좁고 계정 잔액은 레버리지 거래에 대한 담보로 사용할 수 있습니다. GMI INT만 레버리지 수수료를 부과할 수 있습니다.",
    "index09": "GMI INT 커뮤니티에 권한을 부여하도록 설계된 토큰",
    "index10": "Unus Sed LEO는 GMI INT 거래 플랫폼의 이점과 기능을 극대화하려는 사용자가 자신의 요구를 충족할 수 있도록 돕기 위해 설계된 애플리케이션 토큰입니다.",
    "index11": "GMI INT 커뮤니티에 권한을 부여하도록 설계된 토큰",
    "index12": "더 나은 삶으로 가는 길을 열어라",
    "index13": "누구나 암호화폐를 소유할 수 있습니다. 누구나 암호화폐 소프트웨어를 거래할 수 있습니다. Bitget이 한 단계 더 나아갈 수 있는 방법은 다음과 같습니다.",
    "index14": "혁신적인 제품",
    "index15": "원클릭 복사 거래",
    "index16": "거래 시 토큰을 변환하지 마십시오",
    "index17": "USDC 마진을 지원하는 주요 파생상품 거래소",
    "index18": "핫 및 콜드 지갑 격리를 통한 위험 제어",
    "index19": "SSL Labs의 12개 a+ 등급",
    "index20": "Suntwin Technology, Green Pine Cloud Security, HEAP 및 Armors에서 지원하는 신뢰할 수 있는 보안",
    "index21": "훌륭한 고객 서비스",
    "index22": "여러 언어로 연중무휴 온라인 지원",
    "index23": "VIP 고객을 위한 일대일 지원",
    "index24": "커뮤니티 리워드 센터",
    "index25": "상인을 위해 상인이 구축",
    "index26": "비트코인, 이더리움, 솔라나, 도그코인 등 다양한 디지털 자산을 낮은 거래 비용으로 거래",
    "index27": "암호화폐를 구매, 판매, 거래, 투자 및 사용하는 데 필요한 도구 및 정보",
    "index28": "업계 최고의 보안",
  },
  "langNew":{
    "szhb": "암호화폐",
    "gjs": "금속",
    "yy": "조잡한",
    "jy": "거래",
    "jmhb": "암호화폐",
    "yxhy": "영구 계약",
    "gdjy": "미결 주문",
    "khh": "계좌 개설",
    "qsrkhh": "은행에 들어가주세요",
    "yhkh": "은행 계좌",
    "qsryhkh": "은행 계좌 번호를 입력해 주십시오",
    "mnzh":"데모 계정",
    "cjmnzhcg":"데모 계정이 성공적으로 생성되었습니다",
    "tcmnzh":"데모 계정 종료",
   }
}



// WEBPACK FOOTER //
// ./src/lang/kr.js